import Backbone from 'backbone';

import { getEnv } from '@luna/env';
import { AuthorizationType } from '@shared/core-types';

import { RemainingLimitsModel } from './RemainingLimitsModel';

export class RemainingLimitsCollection extends Backbone.Collection {
    // @ts-expect-error: ignore duplicate identifier issue
    url() {
        return `${getEnv().prestoUrl}netbanking/my/orders/payments/limits`;
    }

    initialize() {
        this.model = RemainingLimitsModel;
    }

    parse(data: { remainingLimits: unknown }) {
        return data.remainingLimits;
    }

    getAllLimitsAsObject() {
        return {
            tacLimit: this.getTacLimit(),
            tacMobileLimit: this.getTacMobileLimit(),
            cardTanLimit: this.getCardTanLimit(),
            cardTanMobileLimit: this.getCardTanMobileLimit(),
            sIDLimit: this.getSIDLimit(),
        };
    }

    getTacLimit() {
        return this.findWhere({
            authorizationType: AuthorizationType.TAC,
            channelId: 'NETBANKING',
        });
    }

    getTacMobileLimit() {
        return this.findWhere({
            authorizationType: AuthorizationType.TAC,
            channelId: 'MOBILEBANKING',
        });
    }

    getCardTanLimit() {
        return this.findWhere({ authorizationType: AuthorizationType.CARDTAN });
    }

    getCardTanMobileLimit() {
        return this.findWhere({
            authorizationType: AuthorizationType.CARDTAN,
            channelId: 'MOBILEBANKING',
        });
    }

    getSIDLimit() {
        return this.findWhere({ authorizationType: AuthorizationType.SID });
    }
}
